/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { NotificationContext } from './Notification.context';
export const useNotification = () => {
    const { add, hide } = React.useContext(NotificationContext);
    return React.useMemo(() => ({ show: add, hide }), [add, hide]);
};
